import { render, staticRenderFns } from "./MemberMessageHistoryModal.vue?vue&type=template&id=fbbeb972&scoped=true&"
import script from "./MemberMessageHistoryModal.vue?vue&type=script&lang=js&"
export * from "./MemberMessageHistoryModal.vue?vue&type=script&lang=js&"
import style0 from "./MemberMessageHistoryModal.vue?vue&type=style&index=0&id=fbbeb972&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbbeb972",
  null
  
)

export default component.exports